export const PASSWORD_RESET_CLEAR        = 'PASSWORD_RESET_CLEAR';

export const PASSWORD_RESET_CREATE       = 'PASSWORD_RESET_CREATE';
export const PASSWORD_RESET_CREATE_DONE  = 'PASSWORD_RESET_CREATE_DONE';

export const PASSWORD_RESET_UPDATE       = 'PASSWORD_RESET_UPDATE';
export const PASSWORD_RESET_UPDATE_DONE  = 'PASSWORD_RESET_UPDATE_DONE';



// WEBPACK FOOTER //
// ./app/constants/passwordResetTypes.js